/* eslint-disable @typescript-eslint/naming-convention */
export class NICEClientData {
    AdaHighContrast: boolean;
    AdaScreenReader: boolean;
    AgentReportsDateMode: string;
    AgentReportsFavorite: string;
    AudioAgentMessage: boolean;
    AudioEndContact: boolean;
    AudioNewChat: boolean;
    AudioNewContact: boolean;
    ColorTheme: string;
    ConfigureVoiceThresholdToolTip: boolean;
    GlancePinnedOpen: boolean;
    GlanceSensetivity: string;
    GlanceSensitivity: string;
    LastMessageId: number;
    MultiChatDisplay: boolean;
    MultiChatDisplayKeyStore: boolean;
    NetworkWarnings: boolean;
    Panels: boolean;
    PastLogins: any;
    SonuscacheskipStunTurn: boolean;
    ThemeDirectory: string;
    TwentyFourHourClock: boolean;
    Use24HourTime: boolean;
    VisualAgentMessage: boolean;
    VisualNewChat: boolean;
    VisualNewContact: boolean;
    VisualEndContact: boolean;
    VisualNewContactReply: boolean;
    softPhoneVolume: number;
    SecondaryDevice: string;
    AutoAccept: boolean;
    Ringtone: string;
    SecondaryDeviceDelay: string;
    // Used for SiX
    SiXNewPhoneContactNotification: boolean;
    SiXNewWorkItemContactNotification: boolean;
    SiXNewChatContactNotification: boolean;
    SiXNewEmailContactNotification: boolean;
    SiXNewVoicemailContactNotification: boolean;
    SiXIntegratedSoftphoneVolume: number;
    SiXTemplateFavorites: string;




    constructor(clientData?) {
        Object.assign(this, clientData);
        if (!this.softPhoneVolume)
        {
            this.softPhoneVolume = 0;
        }
        if (!this.SiXIntegratedSoftphoneVolume)
        {
            this.SiXIntegratedSoftphoneVolume = 0;
        }
        // if (clientData != null && clientData !== undefined) {
        //     this.AdaHighContrast = clientData.AdaHighContrast || false;
        //     this.AdaScreenReader = clientData.AdaScreenReader || false;
        //     this.AdaHighContrast = clientData.AdaHighContrast || false;
        //     this.AudioAgentMessage = clientData.AudioAgentMessage || false;
        //     this.AudioEndContact = clientData.AudioEndContact || false;
        //     this.AudioNewChat = clientData.AudioNewChat || false;
        //     this.AudioNewContact = clientData.AudioNewContact || false;
        //     this.ConfigureVoiceThresholdToolTip = clientData.ConfigureVoiceThresholdToolTip || false;
        //     this.GlancePinnedOpen = clientData.GlancePinnedOpen || false;
        //     this.MultiChatDisplay = clientData.AdaHighContrast || false;
        //     this.MultiChatDisplayKeyStore = clientData.MultiChatDisplayKeyStore || false;
        //     this.NetworkWarnings = clientData.NetworkWarnings || false;
        //     this.Panels = clientData.Panels || false;
        //     this.SonuscacheskipStunTurn = clientData.SonuscacheskipStunTurn || false;
        //     this.TwentyFourHourClock = clientData.TwentyFourHourClock || false;
        //     this.Use24HourTime = clientData.Use24HourTime || false;
        //     this.VisualAgentMessage = clientData.VisualAgentMessage || false;
        //     this.VisualNewChat = clientData.VisualNewChat || false;
        //     this.VisualEndContact = clientData.VisualEndContact || false;
        //     this.VisualNewContactReply = clientData.VisualNewContactReply || false;
        //     this.AgentReportsDateMode = clientData.AgentReportsDateMode || '';
        //     this.AgentReportsFavorite = clientData.AgentReportsFavorite || '';
        //     this.ColorTheme = clientData.ColorTheme || '';
        //     this.GlanceSensitivity = clientData.GlanceSensitivity || '';
        //     this.ThemeDirectory = clientData.ThemeDirectory || '';
        //     this.GlanceSensitivity = clientData.GlanceSensitivity || '';
        //     this.GlanceSensetivity = clientData.GlanceSensetivity || '';
        //     this.PastLogins = clientData.PastLogins || {};
        //    // this.LastMessageId = clientData.LastMessageId;

       // }
        //console.log(this);
    }
}

